import { Alert, AlertDescription, AlertIcon, Badge, Box, Button, Container, Heading, Spinner, Tab, TabList, Tabs, Text, VStack, useToast } from '@chakra-ui/react'
import React, { useContext, useState, useEffect } from 'react'
import Navbar from '../compnents/Navbar'
import SideBar from '../compnents/SideBar'
import Footer from '../compnents/Footer'
import AuthContext from '../context/AuthContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SettingsEmployeeManagementFree from './SettingsPages/SettingsEmployeeManagementFree'
import SettingsEmployeeManagementPaid from './SettingsPages/SettingsEmployeeManagementPaid'
import Loading from '../compnents/Loading'
import SettingsCustomerListPaid from './SettingsPages/SettingsCustomerListPaid'
const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction ? process.env.REACT_APP_API_BASE_URL_PROD : process.env.REACT_APP_API_BASE_URL_DEV;

function Settings() {
    const { token, user, isAuthInitializing } = useContext(AuthContext);
    const navigate = useNavigate();
    const toast = useToast();

    const [customers, setCustomers] = useState([]);
    const [loadingCustomers, setLoadingCustomers] = useState(true);

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/content/list-customers?page=1&page_size=10`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setCustomers(res.data.customers.slice(0, 7)); // ensure top 7 only
            } catch (err) {
                console.error("Error fetching customers:", err);
            } finally {
                setLoadingCustomers(false);
            }
        };

        if (user?.subscription !== 'free' && user?.role === 'admin') {
            fetchCustomers();
        }
    }, [token, user]);

    if (isAuthInitializing || !token) {
        return (
            <Loading />
        );
    }

    if (!user) {
        return (
            <Box minH="100vh" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                <Spinner size="xl" color="brand.teal" />
            </Box>
        );
    }

    // Settings stay usable before the first client file: a Team owner can invite
    // colleagues and manage the account first. Only uploads need data.
    const awaitingFirstUpload = user.noOfFileUploads === 0;

    return (
        <Box minH="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box display="flex" flex="1">
                <SideBar />
                <Container maxW="container.xl" flex="1">
                    <VStack spacing={6} align="stretch" py={6}>
                        <Box>
                            <Heading size="lg" color="gray.800">Settings</Heading>
                            <Text mt={2} color="gray.600">
                                Manage account, datasets, domain, and developer access from one workspace area.
                            </Text>
                        </Box>
                        {awaitingFirstUpload && (
                            <Alert status="info" borderRadius="md" data-testid="first-upload-notice">
                                <AlertIcon />
                                <AlertDescription fontSize="sm">
                                    No client file yet. You can set up people and the account now; upload your client
                                    extract from Datasets when you are ready.{' '}
                                    <Button size="xs" variant="link" colorScheme="teal" onClick={() => navigate('/datasets')}>
                                        Go to Datasets
                                    </Button>
                                </AlertDescription>
                            </Alert>
                        )}
                        <Tabs
                            index={0}
                            variant="enclosed"
                            colorScheme="blue"
                            onChange={(index) => {
                                const routes = ['/settings', '/datasets', '/domain', '/docs'];
                                const businessOnly = [false, false, true, true];
                                if (businessOnly[index] && user.subscription !== 'business') {
                                    toast({
                                        title: 'Business feature',
                                        description: index === 2
                                            ? 'Custom domains are part of the Business plan. Upgrade the tenant to configure branded access.'
                                            : 'The developer portal and tenant API keys are part of the Business plan.',
                                        status: 'info',
                                        duration: 4000,
                                        isClosable: true,
                                    });
                                    return;
                                }
                                navigate(routes[index]);
                            }}
                        >
                            <TabList flexWrap="wrap">
                                <Tab>Settings</Tab>
                                <Tab>Datasets</Tab>
                                <Tab>
                                    Your Domain
                                    {user.subscription !== 'business' ? <Badge ml={2} colorScheme="purple">Business</Badge> : null}
                                </Tab>
                                <Tab>
                                    Dev Portal
                                    {user.subscription !== 'business' ? <Badge ml={2} colorScheme="purple">Business</Badge> : null}
                                </Tab>
                            </TabList>
                        </Tabs>

                        {((user.subscription === 'free') && (user.role === 'admin' || user.role === 'rm')) && (
                            <SettingsEmployeeManagementFree />
                        )}
                        {(user.subscription === 'solo' && user.role === 'admin') && (
                            <>
                                <Alert status="info" borderRadius="lg" data-testid="solo-team-upsell">
                                    <AlertIcon />
                                    <AlertDescription>
                                        Solo is a one-person plan: you manage the workspace and work every client yourself.
                                        To invite colleagues and assign clients to them, move to Team from the Subscription page.
                                    </AlertDescription>
                                </Alert>
                                <SettingsCustomerListPaid customers={customers} loadingCustomers={loadingCustomers} />
                            </>
                        )}
                        {(['pro', 'business'].includes(user.subscription) && (user.role === 'admin')) && (
                            <>
                                <SettingsEmployeeManagementPaid />
                                <SettingsCustomerListPaid customers={customers} loadingCustomers={loadingCustomers} />
                            </>
                        )}
                    </VStack>
                    {/* This is shifted to Dashboard.js */}
                    {/* <VStack>
                        {(['solo', 'pro', 'business'].includes(user.subscription) && (user.role === 'rm')) && (
                            <>
                                <SettingsRMownBookPaid />
                                <SettingsRMwhoToCallPaid />
                                <SettingsRMpriorityScores />
                                <SettingsRMriskRanking />
                                <SettingsRMsegments />
                            </>
                        )}
                    </VStack> */}

                </Container>
            </Box>
            <Footer />
        </Box>
    )
}

export default Settings
